export const btnLogin = "Login";
export const btnJoinWaiting = "Join Waiting List";
export const btnRemember = "Remember Me";
export const btnForgotPassword = "Forgot Password?";
export const txtSortByDate = "Sort by date :";
export const txtAllTickets = "All Tickets";
export const btnTermServices = "I accept the Terms & Conditions";
export const btnSendCode = "Send Code";
export const btnSubmit = "Submit";
export const btnSave = "Save";
export const btnTopUp = "Top Up";
export const btnWithdraw = "Withdraw";
export const btnHome = "Home";
export const btnConnect = "Customer Connect";
export const btnTickets = "Tickets";
export const btnOpenJobs = "Open Jobs";
export const btnAssigned = "Assigned ";
export const btnCompleted = "Completed";
export const btnAccept = "Accept Job";
export const btndecline = "Decline Job";
export const btnRead = "Read All";
export const btnDelete = "Delete";
export const btnTurnOff = "Turn Off Notifications";
export const btnSetting = "Setting";
export const btnPersonal = "Personal Info";
export const btnChangePassword = "Change Password";
export const btnAboutUs = "About Us";
export const btnContact = "Contact Us";
export const btnInviteFriends = "Invite Friends";
export const label = "label";
export const btnLogout = "Logout";
export const btnBio = "Bio";
export const btnWorkInfo = "Work Info";
export const btnDocuments = "Documents";
export const btnSaveWork = "Save Work Info";
export const btnInvite = "Invite";
export const btnFree = "Free";
export const btnviewAll = "View All Jobs";
export const btnChoose = "Choose File";
export const btnUpload = "Upload Documents";
export const btnInProgress = "In Progress";
export const btnDone = "Done";
export const btnDecline = "Decline";
export const btnJoinVideo = "Join Video";
export const btnResendLink = "ResendLink";
export const btnDiagnosisReport = "Create Diagnosis Report";
export const btnSendLink = "Send Link";
export const btnFlashOnOff = "Flash On/Off";
export const btnMuteUnmute = "Mute/Unmute";
export const btnSwitchCamera = "Switch Camera";
export const btnZoomIn = "Zoom-In";
export const btnZoomOut = "Zoom-Out";
export const btnZoomReset = "Zoom-Reset";
export const btnDraw = "Draw";
export const btnUserHighlight = "User Highlight";
export const btnClear = "Clear";
export const btnDownload = "Download";
export const btnGoLive = "Go Live";
export const btnUpdateProfile = "Update Profile";
export const btnUpdateProfileLoading = "Updating...";
export const btnSaveWorkLoading = "Saving info";
export const btnSaveExpertise = "Save Expertise";
export const btnSaveExpertiseLoading = "Saving...";
export const btnAddBank = "Add Bank";
export const btnAvailableServices = "Available Services";
export const btnMyServices = "My Services";
export const btnCheckWaitingUsers = "Check Waiting Users";
export const btnAddUser = "Add User";
export const btnFeedback = "Feedback";
export const btnConnectWithPro = "Connect with Pro";
export const btnConnectWithAnotherPro = "Connect with another Pro";
export const btnReInititateService = "Re-initiate service";
export const btnReInititateLoading = "Re-initiating...";
export const btnMarkAsResolved = "Mark as Resolved";
export const btnAcceptService = "Accept";
export const btnRejectService = "Reject";
export const btnRejectedService = "Rejected";
export const btnRejectedServiceMsg = "You have rejected request";
export const btnAcceptedByotherPro = "Accepted By other Professional";
export const alertCameraAccessDenied = "Camera access is denied!";
export const alertAllowAccessToCamera = "Allow access to camera, go to your settings and tap Camera. Application will be restart when changed the settings.";
export const alertAllowAccessToPhotos = "Allow access to your photos.";
export const alertPhotosPermission = "This lets you share from your camera roll and enables other features for photos and videos. Go to your settings and tap Photos.";
export const alertScreenshotSavedMessage = "Screenshot has been saved to your photos.";
export const alertScreenshotSavedMessageError = "Save error";
export const alertMicrophoneAccessDenied = "Microphone access is denied!";
export const alertAllowAccessToMicrophone = "Allow access to microphone, go to your settings and tap Microphone. Application will be restart when changed the settings.";
export const alertTorchUnavailable = "Device torch is currently unavailable, maybe the device overheats and needs to cool off.";
export const alertTorchUnavailableOnFrontCamera = "Device torch mode is currently unavailable for front camera.";
export const alertTurnOnCamera = "Please turn on your camera first then retry.";
export const alertNoParticipation = "Remote participant not available into the room or join the video call.";
export const alertCantDisableVideo = "You can't turn off your camera because professional is drawing.";
export const alertCantStartDrawingOnDisableVideo = "You can't start or stop drawing because remote participant camera is turn off.";
export const alertCantStartDrawingOnNoParticipation = "You can't start drawing because remote participant is not available into room.";
export const alertCantDoUserHighlighWhenProDrawing = "You can't do the user highlight because professional is drawing.";
export const alertDrawingSavedToFiles = "Drawing has been saved to your files.";
export const alertDrawingSavedToPhotos = "Drawing has been saved to your photos.";
export const alertDrawingSavedToCallNotes = "Drawing has been saved to call notes under call history.";
export const alertRestrictedSendEvents = "You can't send contoll event becasue remote participant camera is turn off.";
export const alertDrawingStarted = "Pro has paused your screen to draw.";
export const alertDrawingStoped = "Professional has stopped drawing.";
export const alertDrawingCleared = "Professional has erased the drawing.";
export const validMinimumRating = "Minimum rating should be 1 star.";
export const alertDiscardRecording = "Screen recording is enabled, do you want to save or discard?";
export const alertLindedExpired = "Link is expired, can't able to join video.";
export const alertNoInternet = "Please try again after some time.";
export const alertUnableToPickFile = "Unable to pick file";
export const alertConfrimationDeleteAllRecord = "Are you sure want to delete all records?";
export const alertConfrimationDeleteAttachment = "Are you sure want to delete this attachment?";
export const alertNewVersion = "New version of App is available. Please download from app store.";
export const alertEmptyFullname = "Please enter full name.";
export const alertDeleteCompanyConfirmation = "Are you sure want to delete this company?";
export const alertNoOpenJobsFound = "Currently no jobs waiting to be accepted. Click the Jobs Paused button above and get real time jobs.";

